<template>
  <div style="height: 100%;overflow-y: auto">
    <div style="width: 80%; margin: 20px auto;">
      <div style="width: 40%">
        <el-form ref="form" :model="form" label-width="auto" id="myform">
          <el-form-item label="扫码录入">
            <el-input
              v-model="form.bar_code"
              placeholder="请将鼠标点击在此"
              @change="add_Focus"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品名称">
            <el-input
              v-model="form.title"
              placeholder="请输入商品名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品分类">
            <el-select v-model="form.cate" placeholder="请选择分类">
              <el-option
                v-for="item in Commodity_Category"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                >{{ item.name }}</el-option
              >
            </el-select>
          </el-form-item>
          <el-form-item label="图片上传">
            <el-upload
              action="#"
              ref="upload"
              :show-file-list="false"
              :http-request="
                file => {
                  return upload_index_img(file);
                }
              "
              list-type="picture-card"
              :on-remove="handleRemove"
            >
              <img v-if="form.url" :src="form.url" class="avatar" />
              <i v-else class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="门店" prop="room_id">
            <el-select
              v-model="form.room_id"
              placeholder="请选择门店"
              :disabled="storeSelect.length == 0"
            >
              <el-option
                v-for="item in storeSelect"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                >{{ item.name }}</el-option
              >
            </el-select>
          </el-form-item>
          <el-form-item prop="jq" label="商品售价">
            <el-input
              type="text"
              v-model="form.money"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item prop="jq" label="商品进价">
            <el-input
              type="text"
              v-model="form.price"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="库存" prop="kc">
            <el-input
              type="number"
              v-model="form.stock"
              placeholder="请输入库存"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input
              type="number"
              v-model="form.sort"
              placeholder="排序"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品介绍">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 15 }"
              placeholder="请输入商品介绍"
              v-model="form.brife"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="联盟商品">
            <el-tooltip
              :content="'Switch value: ' + form.alliance_goods"
              placement="top"
            >
              <el-switch
                v-model="form.alliance_goods"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-tooltip>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="edit_shop">提交</el-button>
            <el-button @click="Rutern">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import { Commodity_category, editGoods, productDetail } from "@/api/market";
import { addImage } from "@/api/comment";
import { storeSelect } from "@/api/employee";
import { mapGetters } from "vuex";
import { get_goods_by_barcode } from "@/api/order";

export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  components: {
    newSelectCommodityNum
  },
  data() {
    return {
      imageUrl: "",
      showSelecter: false,
      coupons: [],
      storeSelect: [],
      sList: [],
      Commodity_Category: [],
      fileList: [],
      form: {
        bar_code: "",
        app_id: "",
        title: "",
        cate: "",
        goods_type: 0,
        coupon_id: "",
        balance: "",
        room_id: "",
        logo: "",
        buy_method: 3,
        credit: "",
        money: "",
        stock: "",
        sort: "",
        brife: "",
        notice: "1",
        exchange_process: "1",
        alliance_goods: "0",
        url: ""
      },
      couponName: "",
      show: 0,
      kyes: [
        "id",
        "title",
        "cate",
        "room_id",
        "logo",
        "buy_method",
        "money",
        "stock",
        "sort",
        "brife",
        "alliance_goods",
        "bar_code",
        "goods_type",
        "url",
        "price",

      ]
    };
  },
  mounted() {
    this.Commodity_category();
    this.getMendian();
    this.getproductDetail();
  },
  methods: {
    //商品详情
    async getproductDetail() {
      const res = await productDetail({
        app_id: this.app_id,
        id: this.$route.query.id
      });
      if (res.code == 200) {
        this.form = res.data;
        if(res.data.url){
          this.form.url = res.data.url
        }else{
          this.form.url = res.data.pic
        }
      }
    },
    //扫码枪录入
    async add_Focus(val) {
      const res = await get_goods_by_barcode({
        app_id: this.app_id,
        bar_code: val
      });
      if (res.code == 200) {
        let data = res.data;
        if (res.data.name) this.form.title = data.name;
        if (res.data.pic) {
          this.form.url = data.pic;
        } else {
          this.form.url = "";
        }
        if (res.data.price) {
          var index = res.data.price.lastIndexOf("\￥");
          console.log("index", index);
          if (index!=-1) {
            this.form.money = res.data.price.substring(
              index + 1,
              res.data.price.length
            );
            this.form.price = res.data.price.substring(
              index + 1,
              res.data.price.length
            );
          } else {
            this.form.money = res.data.price;
            this.form.price = res.data.price;
          }
        }
        for (let key in data) {
          if (!data[key]) {
            data[key] = "";
          }
        }
        this.form.brife =
          "名称: " +
          data.name +
          "\n" +
          "品牌: " +
          res.data.brand +
          "\n" +
          "规格型号: " +
          res.data.type +
          "\n" +
          "关键词: " +
          res.data.keyword +
          "\n" +
          "所属公司: " +
          res.data.company +
          "\n" +
          "商品有效期: " +
          res.data.expirationdate +
          "\n" +
          "净含量: " +
          res.data.netcontent +
          "\n" +
          "\n" +
          res.data.description;
      }else {
        this.$message.error(res.msg)
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      console.log("删除", file);
      this.fileList.shift();
      this.form.logo = "";
    },
    //返回
    Rutern() {
      this.$router.back(-1);
    },
    //编辑
    edit_shop() {
      for(var key in this.form){
        if(!this.kyes.includes(key)){
          delete this.form[key];
        }
      }
      console.log(this.form)
      this.form.app_id = this.app_id;
      editGoods(this.form).then(res => {
        console.log("tianjia ", res);
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success"
          });
          setTimeout(() => {
            document.getElementById("myform").reset();
            // if (this.form.logo) {
            // 	this.$refs.upload.clearFiles();
            // }
            this.$router.back(-1);
            this.form.logo = "";
          }, 100);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //获取商品类目
    async Commodity_category() {
      const res = await Commodity_category({
        app_id: this.app_id
      });
      if (res.code == 200) {
        console.log(res);
        this.Commodity_Category = res.data;
      }
    },
    //获取门店
    getMendian() {
      storeSelect({ token: this.token, app_id: this.app_id }).then(res => {
        console.log("门店", res);
        this.storeSelect = res.data;
        
      });
    },
    upload_index_img(file) {
      console.log("wenjian", file.file);
      var formdata = new FormData();
      formdata.append("token", this.token);
      formdata.append("image", file.file);
      formdata.append("type", "1");
      formdata.append("file_group", "1");
      addImage(formdata).then(res => {
        if (res.code == 200) {
          console.log("tu", res);
          var data = res.data;
          this.form.logo = data.id;
          this.form.url = data.url;
        } else {
          this.$message.warning(res.msg);
        }
      });
    }
    // //二维码
    // qrcode() {
    // 	let text =
    // 		BASE_URL + "/shopList?token=" + this.token + "&app_id=" + this.app_id;
    // 	let qrcode = new QRCode("qrcode", {
    // 		width: 160, // 设置宽度，单位像素
    // 		height: 160, // 设置高度，单位像素
    // 		text: text,
    // 		colorDark: "#000000",
    // 		colorLight: "#ffffff",
    // 		correctLevel: 3,
    // 	});
    // },
  }
};
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #000;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.avatar {
  width: 100%;
  height: 100%;
  display: block;
}
.content .upload-demo ::v-deep .el-upload–text {
  border: 1px solid black;
}
</style>
